import { createContext } from "react";
import type { BasicActionSource } from "./BasicActionSource";

export type HotkeysContext = {
  actionSource: BasicActionSource;
};

export const hotkeysContext = createContext<HotkeysContext>(null!);
